/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Chip,
  Checkbox,
  Tooltip,
  IconButton,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ReceiptIcon from "@material-ui/icons/Receipt";
import TodayIcon from "@material-ui/icons/Today";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CloseIcon from "@material-ui/icons/Close";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import InfoIcon from "@material-ui/icons/Info";
import EditIcon from "@material-ui/icons/Edit";
import PersonIcon from "@material-ui/icons/Person";
import moment from "moment";
import "moment/locale/th";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Label } from "reactstrap";

import TSSelect2 from "components/Forms/TSSelect2";
import { BeamService } from "_services/beam.service";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    fontFamily: '"Sarabun", "Tahoma", sans-serif',
    backgroundColor: "#f8fafc",
    minHeight: "100vh"
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2)
  },
  title: {
    fontWeight: "bold",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    fontSize: "1.5rem"
  },
  subTitle: {
    color: "#64748b",
    fontSize: "0.875rem",
    marginTop: 4
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    border: "1px solid #e2e8f0",
    overflow: "visible !important",
    position: "relative",
    zIndex: 50
  },
  datetimeInputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    zIndex: 100,
    width: "100%",
    "& .rdt": {
      width: "100%",
      position: "relative"
    },
    "& .rdtPicker": {
      position: "absolute",
      top: "calc(100% + 4px)",
      left: 0,
      zIndex: 99999,
      backgroundColor: "#ffffff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
      borderRadius: "8px",
      border: "1px solid #cbd5e1",
      fontSize: "13px",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "& table": {
        margin: 0
      },
      "& table th, & table td": {
        fontSize: "13px",
        height: "26px",
        padding: "2px"
      },
      "& .rdtSwitch": {
        fontSize: "13px",
        fontWeight: "bold"
      }
    },
    "& .form-control": {
      height: 40,
      borderRadius: 8,
      border: "1px solid #cbd5e1",
      paddingLeft: 38,
      paddingRight: 12,
      fontSize: "0.875rem",
      color: "#0f172a",
      width: "100%",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "&:hover": {
        borderColor: "#94a3b8"
      },
      "&:focus": {
        borderColor: "#2563eb",
        boxShadow: "0 0 0 2px rgba(37,99,235,0.15)",
        outline: "none"
      }
    }
  },
  datetimeIcon: {
    position: "absolute",
    left: 12,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#64748b",
    pointerEvents: "none",
    zIndex: 1,
    fontSize: 16
  },
  summaryCard: {
    padding: theme.spacing(2.5),
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    border: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    height: "100%"
  },
  summaryIconBox: {
    width: 52,
    height: 52,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  summaryTitle: {
    fontSize: "0.875rem",
    color: "#64748b",
    fontWeight: 500
  },
  summaryValue: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#0f172a",
    marginTop: 2
  },
  tableCard: {
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    border: "1px solid #e2e8f0",
    overflow: "hidden"
  },
  table: {
    minWidth: 800,
    "& th": {
      backgroundColor: "#f1f5f9",
      fontWeight: "bold",
      color: "#334155",
      fontSize: "0.9rem",
      padding: "12px 14px",
      whiteSpace: "nowrap"
    },
    "& td": {
      fontSize: "0.9rem",
      padding: "12px 14px",
      color: "#1e293b"
    },
    "& tbody tr:hover": {
      backgroundColor: "#f8fafc"
    }
  },
  searchField: {
    width: "100%",
    maxWidth: 320
  },
  previewTable: {
    width: "100%",
    borderCollapse: "collapse",
    "& th": {
      backgroundColor: "#f1f5f9",
      fontWeight: "bold",
      color: "#334155",
      fontSize: "0.85rem",
      padding: "8px 12px",
      borderBottom: "1px solid #cbd5e1"
    },
    "& td": {
      fontSize: "0.85rem",
      padding: "8px 12px",
      borderBottom: "1px solid #e2e8f0"
    }
  }
}));

/**
 * คำนวณลำดับ BookNum และ DocNum โดยมีเงื่อนไข:
 * docnum เริ่มต้นรันถึง 99 เมื่อถึง 99 จะหยุดที่ 99 แล้วขึ้น booknum ใหม่ (+1) และเริ่ม docnum ใหม่ที่ 1
 */
export function calculateSequentialNumbers(startBook, startDoc, count) {
  let book = parseInt(startBook, 10);
  let doc = parseInt(startDoc, 10);

  if (isNaN(book) || book <= 0 || isNaN(doc) || doc < 1 || doc > 99) {
    return [];
  }

  const results = [];
  for (let i = 0; i < count; i++) {
    results.push({
      bookNum: String(book),
      docNum: String(doc).padStart(2, "0"),
      formatted: `${book}/${String(doc).padStart(2, "0")}`
    });

    if (doc >= 99) {
      book += 1;
      doc = 1;
    } else {
      doc += 1;
    }
  }
  return results;
}

export default function BeamReceiptNumberView() {
  const classes = useStyles();

  // ตัวกรองวันที่: เลือกได้แบบวันเดียว (default: วันนี้)
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));

  // ตัวกรองสถานะ: 'all', 'unassigned' (ยังไม่ออกเลข), 'assigned' (ออกเลขแล้ว)
  const [statusFilter, setStatusFilter] = useState("all");

  // ข้อมูลจาก API
  const [loading, setLoading] = useState(false);
  const [receipts, setReceipts] = useState([]);
  const [summary, setSummary] = useState({
    totalCount: 0,
    assignedCount: 0,
    unassignedCount: 0,
    totalAmount: 0
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  // ค้นหาในหน้า
  const [searchTerm, setSearchTerm] = useState("");

  // Checkbox selection: เก็บ receiptHeaderKey
  const [selectedKeys, setSelectedKeys] = useState([]);

  // Modal ออกเลขใบเสร็จ
  const [modalOpen, setModalOpen] = useState(false);
  const [startBookNum, setStartBookNum] = useState("");
  const [startDocNum, setStartDocNum] = useState("");
  const [recorders, setRecorders] = useState([]);
  const [selectedRecorderKey, setSelectedRecorderKey] = useState("");
  const [modalSaving, setModalSaving] = useState(false);
  const [modalError, setModalError] = useState("");

  // Modal เปลี่ยนผู้ออกใบเสร็จรายบุคคล
  const [changeRecorderModalOpen, setChangeRecorderModalOpen] = useState(false);
  const [targetReceipt, setTargetReceipt] = useState(null);
  const [editRecorderKey, setEditRecorderKey] = useState("");
  const [changeRecorderSaving, setChangeRecorderSaving] = useState(false);
  const [changeRecorderError, setChangeRecorderError] = useState("");

  // โหลดรายชื่อผู้ออกใบเสร็จเมื่อ component mount
  useEffect(() => {
    loadRecorders();
  }, []);

  const loadRecorders = async () => {
    try {
      const res = await BeamService.getReceiptRecorders();
      if (res && res.data && res.data.success) {
        setRecorders(res.data.data || []);
      }
    } catch (err) {
      console.error("Error loading receipt recorders:", err);
    }
  };

  // โหลดข้อมูลเมื่อวันที่หรือสถานะเปลี่ยน
  useEffect(() => {
    loadData();
  }, [selectedDate, statusFilter]);

  const loadData = async () => {
    if (!selectedDate) return;
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const res = await BeamService.getPaymentType3Receipts({
        date: selectedDate,
        status: statusFilter
      });

      if (res && res.data && res.data.success) {
        const data = res.data.data || [];
        setReceipts(data);
        setSummary({
          totalCount: res.data.totalCount || data.length,
          assignedCount: res.data.assignedCount || data.filter(r => r.hasReceiptNumber).length,
          unassignedCount: res.data.unassignedCount || data.filter(r => !r.hasReceiptNumber).length,
          totalAmount: res.data.totalAmount || data.reduce((acc, curr) => acc + Number(curr.amount || 0), 0)
        });

        // ล้าง selection ที่ไม่มีอยู่ในข้อมูลใหม่
        const newKeysSet = new Set(data.map(d => d.receiptHeaderKey));
        setSelectedKeys(prev => prev.filter(k => newKeysSet.has(k)));
      } else {
        const msg = (res && res.data && res.data.message) || "ไม่สามารถดึงข้อมูลใบเสร็จได้";
        setErrorMsg(msg);
        setReceipts([]);
      }
    } catch (err) {
      console.error("Error loading PaymentType=3 receipts:", err);
      const msg = (err.response && err.response.data && err.response.data.message) || "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
      setErrorMsg(msg);
      setReceipts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchSubmit = e => {
    if (e) e.preventDefault();
    loadData();
  };

  // กรองค้นหาในหน้าบ้าน (ค้นหา RefCode, HN, FullName, ผู้ออกใบเสร็จ, ReceiptNo, BookNum/DocNum)
  const filteredData = receipts.filter(t => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase().trim();
    const ref = (t.refCode || "").toLowerCase();
    const hn = (t.hn || "").toLowerCase();
    const name = (t.fullName || "").toLowerCase();
    const recorder = (t.recorderName || "").toLowerCase();
    const rNo = (t.receiptNo || "").toLowerCase();
    const doc = (t.docNum || "").toLowerCase();
    const book = (t.bookNum || "").toLowerCase();
    const bookDoc = `${book}/${doc}`.toLowerCase();

    return (
      ref.includes(term) ||
      hn.includes(term) ||
      name.includes(term) ||
      recorder.includes(term) ||
      rNo.includes(term) ||
      doc.includes(term) ||
      book.includes(term) ||
      bookDoc.includes(term)
    );
  });

  // รายการที่ "ยังไม่ออกเลข" เท่านั้นที่มีสิทธิ์เลือก checkbox
  const eligibleRecords = filteredData.filter(r => !r.hasReceiptNumber && (!r.bookNum || !r.docNum));
  const isAllEligibleChecked =
    eligibleRecords.length > 0 && eligibleRecords.every(r => selectedKeys.includes(r.receiptHeaderKey));
  const isSomeEligibleChecked =
    eligibleRecords.some(r => selectedKeys.includes(r.receiptHeaderKey)) && !isAllEligibleChecked;

  // Toggle Check All (เฉพาะ record ที่ยังไม่ออกเลข)
  const handleToggleSelectAll = () => {
    if (isAllEligibleChecked) {
      // ยกเลิกเลือกทั้งหมดสำหรับ eligible
      const eligibleSet = new Set(eligibleRecords.map(r => r.receiptHeaderKey));
      setSelectedKeys(prev => prev.filter(k => !eligibleSet.has(k)));
    } else {
      // เลือกทั้งหมดสำหรับ eligible
      const eligibleKeys = eligibleRecords.map(r => r.receiptHeaderKey);
      setSelectedKeys(prev => Array.from(new Set([...prev, ...eligibleKeys])));
    }
  };

  // Toggle Checkbox แต่ละ record
  const handleToggleRow = key => {
    setSelectedKeys(prev => {
      if (prev.includes(key)) {
        return prev.filter(k => k !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  // รายการที่ถูกเลือกตามลำดับใน filteredData
  const selectedItems = filteredData.filter(r => selectedKeys.includes(r.receiptHeaderKey));

  // คำนวณตัวอย่างเลขที่จะออก
  const previewSequence = calculateSequentialNumbers(startBookNum, startDocNum, selectedItems.length);

  // ตรวจสอบว่ามีการขึ้นเล่มใหม่หรือไม่
  const hasBookRollover =
    previewSequence.length > 0 &&
    previewSequence[0].bookNum !== previewSequence[previewSequence.length - 1].bookNum;

  // เปิด Modal ออกเลข
  const handleOpenAssignModal = () => {
    if (selectedKeys.length === 0) return;
    setModalError("");
    // กำหนดค่าเริ่มต้นของผู้ออกใบเสร็จ
    const itemWithRecorder = selectedItems.find(r => r.recorderKey);
    if (itemWithRecorder && itemWithRecorder.recorderKey) {
      setSelectedRecorderKey(itemWithRecorder.recorderKey);
    } else if (!selectedRecorderKey && recorders.length > 0) {
      setSelectedRecorderKey(recorders[0].recorderKey);
    }
    setModalOpen(true);
  };

  // บันทึกออกเลข
  const handleConfirmAssign = async () => {
    const book = parseInt(startBookNum, 10);
    const doc = parseInt(startDocNum, 10);

    if (isNaN(book) || book <= 0) {
      setModalError("กรุณากรอกเล่มที่ (BookNum) ให้ถูกต้อง (ตัวเลขมากกว่า 0)");
      return;
    }
    if (isNaN(doc) || doc < 1 || doc > 99) {
      setModalError("กรุณากรอกเลขที่เริ่มต้น (DocNum) ให้ถูกต้อง (ตัวเลขระหว่าง 1 ถึง 99)");
      return;
    }
    if (!selectedRecorderKey) {
      setModalError("กรุณาเลือกผู้ออกใบเสร็จ");
      return;
    }
    if (selectedKeys.length === 0) {
      setModalError("กรุณาเลือกอย่างน้อย 1 รายการ");
      return;
    }

    setModalSaving(true);
    setModalError("");

    try {
      const res = await BeamService.assignReceiptNumbers({
        startBookNum: String(book),
        startDocNum: String(doc),
        recorderKey: Number(selectedRecorderKey),
        receiptHeaderKeys: selectedKeys
      });

      if (res && res.data && res.data.success) {
        setSuccessMsg(res.data.message || `ออกเลขใบเสร็จสำเร็จ ${selectedKeys.length} รายการ`);
        setModalOpen(false);
        setSelectedKeys([]);
        setStartBookNum("");
        setStartDocNum("");
        // โหลดข้อมูลใหม่เพื่อให้แสดงเลขที่ออกแล้ว
        loadData();
      } else {
        const msg = (res && res.data && res.data.message) || "เกิดข้อผิดพลาดในการบันทึกออกเลขใบเสร็จ";
        setModalError(msg);
      }
    } catch (err) {
      console.error("Error assigning receipt numbers:", err);
      const msg = (err.response && err.response.data && err.response.data.message) || "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
      setModalError(msg);
    } finally {
      setModalSaving(false);
    }
  };

  // เปิด Modal เปลี่ยนผู้ออกใบเสร็จรายบุคคล (เปลี่ยนได้แม้จะออกเลขแล้ว)
  const handleOpenChangeRecorderModal = receipt => {
    setTargetReceipt(receipt);
    setEditRecorderKey(receipt.recorderKey ? String(receipt.recorderKey) : "");
    setChangeRecorderError("");
    setChangeRecorderModalOpen(true);
  };

  // บันทึกเปลี่ยนผู้ออกใบเสร็จรายบุคคล
  const handleConfirmChangeRecorder = async () => {
    if (!targetReceipt || !targetReceipt.receiptHeaderKey) return;
    if (!editRecorderKey) {
      setChangeRecorderError("กรุณาเลือกผู้ออกใบเสร็จ");
      return;
    }

    setChangeRecorderSaving(true);
    setChangeRecorderError("");

    try {
      const res = await BeamService.updateReceiptRecorder({
        receiptHeaderKey: targetReceipt.receiptHeaderKey,
        recorderKey: Number(editRecorderKey)
      });

      if (res && res.data && res.data.success) {
        const newName =
          res.data.recorderName ||
          (recorders.find(r => String(r.recorderKey) === String(editRecorderKey)) || {}).recorderName ||
          "";

        // อัปเดตข้อมูลในตารางทันที
        setReceipts(prev =>
          prev.map(r =>
            r.receiptHeaderKey === targetReceipt.receiptHeaderKey
              ? { ...r, recorderKey: Number(editRecorderKey), recorderName: newName }
              : r
          )
        );

        setSuccessMsg(
          `เปลี่ยนผู้ออกใบเสร็จสำหรับ ${targetReceipt.fullName || targetReceipt.hn || "รายการ"} เป็น "${newName}" เรียบร้อยแล้ว`
        );
        setChangeRecorderModalOpen(false);
        setTargetReceipt(null);
      } else {
        const msg = (res && res.data && res.data.message) || "เกิดข้อผิดพลาดในการเปลี่ยนผู้ออกใบเสร็จ";
        setChangeRecorderError(msg);
      }
    } catch (err) {
      console.error("Error updating receipt recorder:", err);
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
      setChangeRecorderError(msg);
    } finally {
      setChangeRecorderSaving(false);
    }
  };

  const formatThaiDateTime = dateVal => {
    if (!dateVal) return "-";
    const m = moment(dateVal);
    if (!m.isValid()) return "-";
    const beYear = m.year() + 543;
    return `${m.format("DD/MM")}/${beYear} ${m.format("HH:mm:ss")}`;
  };

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        <div>
          <Typography variant="h5" className={classes.title}>
            <ConfirmationNumberIcon style={{ color: "#2563eb", fontSize: 32 }} />
            ออกเลขใบเสร็จ (BeamCheckout)
          </Typography>
          <Typography variant="body2" className={classes.subTitle}>
            จัดการและออกเลขเล่มที่/เลขที่ใบเสร็จรับเงินสำหรับรายการชำระเงินประเภท PromptPay (PaymentType = 3)
          </Typography>
        </div>
        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<RefreshIcon />}
            onClick={loadData}
            disabled={loading}
            style={{ borderRadius: 8, height: 40 }}
          >
            รีเฟรช
          </Button>
        </Box>
      </div>

      {/* Filter Card */}
      <Card className={classes.filterCard} style={{ overflow: "visible", position: "relative", zIndex: 60 }}>
        <CardContent style={{ padding: 20, overflow: "visible" }}>
          <form onSubmit={handleSearchSubmit} style={{ overflow: "visible", position: "relative" }}>
            <Grid container spacing={2} alignItems="flex-end" style={{ overflow: "visible", position: "relative" }}>
              {/* Date Filter: Single Date Only */}
              <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 100 }}>
                <Label
                  style={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#334155",
                    marginBottom: 6,
                    display: "inline-block"
                  }}
                >
                  เลือกวันที่ (วันเดียว)
                </Label>
                <div className={classes.datetimeInputWrapper}>
                  <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                  <Datetime
                    value={selectedDate ? moment(selectedDate) : null}
                    dateFormat="DD/MM/BBBB"
                    timeFormat={false}
                    closeOnSelect={true}
                    renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                    inputProps={{
                      placeholder: "วว/ดด/ปปปป",
                      "aria-label": "เลือกวันที่"
                    }}
                    onChange={m => {
                      if (moment.isMoment(m)) {
                        setSelectedDate(m.format("YYYY-MM-DD"));
                      } else if (typeof m === "string") {
                        setSelectedDate(m);
                      } else if (!m) {
                        setSelectedDate("");
                      }
                    }}
                  />
                </div>
              </Grid>

              {/* Quick Date Buttons */}
              <Grid item xs={12} sm={6} md={2} style={{ position: "relative", zIndex: 90 }}>
                <Box display="flex" gap={1}>
                  <Button
                    size="small"
                    variant={selectedDate === moment().format("YYYY-MM-DD") ? "contained" : "outlined"}
                    color="primary"
                    onClick={() => setSelectedDate(moment().format("YYYY-MM-DD"))}
                    style={{
                      height: 40,
                      borderRadius: 8,
                      flex: 1,
                      backgroundColor: selectedDate === moment().format("YYYY-MM-DD") ? "#2563eb" : "transparent"
                    }}
                  >
                    วันนี้
                  </Button>
                  <Button
                    size="small"
                    variant={selectedDate === moment().subtract(1, "days").format("YYYY-MM-DD") ? "contained" : "outlined"}
                    onClick={() => setSelectedDate(moment().subtract(1, "days").format("YYYY-MM-DD"))}
                    style={{
                      height: 40,
                      borderRadius: 8,
                      flex: 1,
                      backgroundColor: selectedDate === moment().subtract(1, "days").format("YYYY-MM-DD") ? "#2563eb" : "transparent",
                      color: selectedDate === moment().subtract(1, "days").format("YYYY-MM-DD") ? "#fff" : "inherit"
                    }}
                  >
                    เมื่อวาน
                  </Button>
                </Box>
              </Grid>

              {/* Status Filter (ออกเลขแล้ว / ยังไม่ออกเลข / ทั้งหมด) */}
              <Grid item xs={12} sm={6} md={3} style={{ position: "relative", zIndex: 80 }}>
                <TSSelect2
                  label="สถานะเลขที่ใบเสร็จ"
                  options={[
                    { value: "all", label: "ทั้งหมด (ทุกสถานะ)" },
                    { value: "unassigned", label: "ยังไม่ออกเลขใบเสร็จ" },
                    { value: "assigned", label: "ออกเลขใบเสร็จแล้ว" }
                  ]}
                  value={statusFilter}
                  onChange={opt => setStatusFilter(opt ? opt.value : "all")}
                  isClearable={false}
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12} sm={6} md={2} style={{ position: "relative", zIndex: 70 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SearchIcon />}
                  disabled={loading}
                  style={{
                    backgroundColor: "#2563eb",
                    color: "#fff",
                    height: 40,
                    borderRadius: 8,
                    fontWeight: "bold"
                  }}
                >
                  ค้นหา
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      {/* Summary Stat Cards */}
      <Grid container spacing={3} style={{ marginBottom: 24 }}>
        <Grid item xs={12} sm={6} md={3}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#eff6ff", color: "#2563eb" }}>
              <ReceiptIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>รายการทั้งหมด</div>
              <div className={classes.summaryValue}>
                {summary.totalCount.toLocaleString()}{" "}
                <span style={{ fontSize: "0.95rem", fontWeight: "normal", color: "#64748b" }}>รายการ</span>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#fef3c7", color: "#d97706" }}>
              <ConfirmationNumberIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>ยังไม่ออกเลขใบเสร็จ</div>
              <div className={classes.summaryValue} style={{ color: "#d97706" }}>
                {summary.unassignedCount.toLocaleString()}{" "}
                <span style={{ fontSize: "0.95rem", fontWeight: "normal", color: "#64748b" }}>รายการ</span>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#ecfdf5", color: "#16a34a" }}>
              <CheckCircleIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>ออกเลขใบเสร็จแล้ว</div>
              <div className={classes.summaryValue} style={{ color: "#16a34a" }}>
                {summary.assignedCount.toLocaleString()}{" "}
                <span style={{ fontSize: "0.95rem", fontWeight: "normal", color: "#64748b" }}>รายการ</span>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#ecfdf5", color: "#059669" }}>
              <MonetizationOnIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>ยอดเงินรวม (บาท)</div>
              <div className={classes.summaryValue} style={{ color: "#059669" }}>
                {Number(summary.totalAmount || 0).toLocaleString("th-TH", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}{" "}
                <span style={{ fontSize: "0.95rem", fontWeight: "normal", color: "#64748b" }}>บาท</span>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* Alert Messages */}
      {errorMsg && (
        <Box
          display="flex"
          alignItems="center"
          gap={1.5}
          p={2}
          mb={3}
          style={{
            backgroundColor: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: 8,
            color: "#b91c1c"
          }}
        >
          <ErrorOutlineIcon />
          <Typography variant="body2">{errorMsg}</Typography>
        </Box>
      )}

      {successMsg && (
        <Box
          display="flex"
          alignItems="center"
          gap={1.5}
          p={2}
          mb={3}
          style={{
            backgroundColor: "#ecfdf5",
            border: "1px solid #a7f3d0",
            borderRadius: 8,
            color: "#065f46"
          }}
        >
          <CheckCircleIcon />
          <Typography variant="body2" style={{ fontWeight: "bold" }}>
            {successMsg}
          </Typography>
        </Box>
      )}

      {/* Table Card */}
      <Card className={classes.tableCard}>
        <Box
          p={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={2}
          style={{ borderBottom: "1px solid #e2e8f0" }}
        >
          <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
            <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#0f172a" }}>
              รายการใบเสร็จ ({filteredData.length} รายการ)
            </Typography>
            {selectedKeys.length > 0 && (
              <Chip
                size="small"
                label={`เลือกแล้ว ${selectedKeys.length} รายการ`}
                style={{ backgroundColor: "#dbeafe", color: "#1d4ed8", fontWeight: "bold" }}
              />
            )}
          </Box>

          <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
            <TextField
              size="small"
              variant="outlined"
              placeholder="ค้นหา HN, ชื่อผู้ป่วย, เลขที่ใบเสร็จ..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className={classes.searchField}
              style={{ maxWidth: 280 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "#94a3b8" }} />
                  </InputAdornment>
                )
              }}
            />

            {/* ปุ่ม ออกเลขหนังสือ (เปิด Modal Popup) */}
            <Button
              variant="contained"
              color="primary"
              disabled={selectedKeys.length === 0}
              startIcon={<AssignmentTurnedInIcon />}
              onClick={handleOpenAssignModal}
              style={{
                backgroundColor: selectedKeys.length > 0 ? "#16a34a" : "#94a3b8",
                color: "#ffffff",
                fontWeight: "bold",
                borderRadius: 8,
                height: 38
              }}
            >
              ออกเลขหนังสือ {selectedKeys.length > 0 ? `(${selectedKeys.length})` : ""}
            </Button>
          </Box>
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {/* Checkbox Header (Check All เฉพาะ record ที่ยังไม่ออกเลข) */}
                <TableCell style={{ width: 48, textAlign: "center", padding: "8px 4px" }}>
                  <Tooltip title={eligibleRecords.length > 0 ? "เลือกทั้งหมด (เฉพาะรายการที่ยังไม่ออกเลข)" : "ไม่มีรายการที่สามารถเลือกได้"}>
                    <span>
                      <Checkbox
                        color="primary"
                        checked={isAllEligibleChecked}
                        indeterminate={isSomeEligibleChecked}
                        disabled={eligibleRecords.length === 0}
                        onChange={handleToggleSelectAll}
                        inputProps={{ "aria-label": "เลือกทั้งหมด" }}
                      />
                    </span>
                  </Tooltip>
                </TableCell>
                <TableCell style={{ width: 50, textAlign: "center" }}>ลำดับ</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 90 }}>HN</TableCell>
                <TableCell style={{ minWidth: 160 }}>ชื่อ-นามสกุล ผู้ป่วย</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 110 }}>เลขที่ใบเสร็จ</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 120 }}>เล่มที่/เลขที่</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 140 }}>ผู้ออกใบเสร็จ</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 140 }}>วัน-เวลาชำระเงิน</TableCell>
                <TableCell style={{ textAlign: "right", minWidth: 100 }}>ยอดเงิน (บาท)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={9} style={{ textAlign: "center", padding: "40px 0" }}>
                    <CircularProgress size={32} />
                    <Typography variant="body2" style={{ color: "#64748b", marginTop: 8 }}>
                      กำลังโหลดข้อมูลใบเสร็จรับเงิน (PaymentType=3)...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} style={{ textAlign: "center", padding: "40px 0", color: "#64748b" }}>
                    ไม่พบข้อมูลใบเสร็จตามเงื่อนไขที่ระบุ
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.map((row, index) => {
                  const hasAssigned = Boolean(row.bookNum && row.docNum);
                  const isChecked = selectedKeys.includes(row.receiptHeaderKey);

                  return (
                    <TableRow
                      key={row.receiptHeaderKey || index}
                      style={{
                        backgroundColor: isChecked ? "#f0fdf4" : "inherit"
                      }}
                    >
                      {/* Checkbox Column: Record ไหนมี booknum docnum แล้ว ต้องไม่มี checkbox */}
                      <TableCell style={{ textAlign: "center", padding: "8px 4px" }}>
                        {hasAssigned ? (
                          <Tooltip title="ออกเลขใบเสร็จแล้ว">
                            <CheckCircleIcon style={{ color: "#16a34a", fontSize: 20 }} />
                          </Tooltip>
                        ) : (
                          <Checkbox
                            color="primary"
                            checked={isChecked}
                            onChange={() => handleToggleRow(row.receiptHeaderKey)}
                            inputProps={{ "aria-label": `เลือกใบเสร็จ ${row.receiptNo || index + 1}` }}
                          />
                        )}
                      </TableCell>

                      <TableCell style={{ textAlign: "center", color: "#64748b" }}>
                        {index + 1}
                      </TableCell>

                      <TableCell style={{ textAlign: "center", fontWeight: "bold", color: "#1e293b" }}>
                        {row.hn ? (
                          <Chip size="small" label={row.hn} style={{ backgroundColor: "#e2e8f0", fontWeight: "bold" }} />
                        ) : (
                          <span style={{ color: "#94a3b8" }}>-</span>
                        )}
                      </TableCell>

                      <TableCell>
                        <div style={{ fontWeight: 600, color: "#0f172a" }}>
                          {row.fullName || <span style={{ color: "#94a3b8" }}>-</span>}
                        </div>
                        {row.refCode && (
                          <div style={{ fontFamily: "monospace", fontSize: "0.75rem", color: "#64748b" }}>
                            Ref: {row.refCode}
                          </div>
                        )}
                      </TableCell>

                      <TableCell style={{ textAlign: "center", fontWeight: 500, color: "#1e293b" }}>
                        {row.receiptNo ? (
                          <Chip size="small" variant="outlined" label={row.receiptNo} style={{ borderColor: "#cbd5e1" }} />
                        ) : (
                          <span style={{ color: "#94a3b8" }}>-</span>
                        )}
                      </TableCell>

                      {/* เล่มที่/เลขที่ */}
                      <TableCell style={{ textAlign: "center" }}>
                        {hasAssigned ? (
                          <Chip
                            size="small"
                            variant="outlined"
                            label={`${row.bookNum}/${String(row.docNum).padStart(2, "0")}`}
                            style={{
                              borderColor: "#16a34a",
                              color: "#166534",
                              backgroundColor: "#f0fdf4",
                              fontWeight: "bold"
                            }}
                          />
                        ) : (
                          <Chip
                            size="small"
                            label="ยังไม่ออกเลข"
                            style={{ backgroundColor: "#fef3c7", color: "#92400e", fontSize: "0.75rem" }}
                          />
                        )}
                      </TableCell>

                      {/* ผู้ออกใบเสร็จ (กดทีละคนเพื่อเปลี่ยนชื่อคนได้ โดยแสดง popup และ TSSelect2 เปลี่ยนได้แม้จะออกเลขใบเสร็จแล้ว) */}
                      <TableCell style={{ textAlign: "center" }}>
                        <Tooltip title="คลิกเพื่อเปลี่ยนผู้ออกใบเสร็จ">
                          <Button
                            size="small"
                            onClick={() => handleOpenChangeRecorderModal(row)}
                            style={{
                              textTransform: "none",
                              fontFamily: '"Sarabun", "Tahoma", sans-serif',
                              fontSize: "0.85rem",
                              fontWeight: 600,
                              color: row.recorderName ? "#0f172a" : "#64748b",
                              backgroundColor: row.recorderName ? "#f8fafc" : "#ffffff",
                              border: "1px solid #cbd5e1",
                              borderRadius: 6,
                              padding: "2px 8px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 4
                            }}
                          >
                            <span>{row.recorderName || "ระบุผู้รับเงิน"}</span>
                            <EditIcon style={{ fontSize: 14, color: "#2563eb" }} />
                          </Button>
                        </Tooltip>
                      </TableCell>

                      <TableCell style={{ textAlign: "center", color: "#334155" }}>
                        {formatThaiDateTime(row.transactionTime)}
                      </TableCell>

                      <TableCell style={{ textAlign: "right", fontWeight: "bold", color: "#0f172a" }}>
                        {Number(row.amount || 0).toLocaleString("th-TH", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}

              {filteredData.length > 0 && (
                <TableRow style={{ backgroundColor: "#f8fafc", fontWeight: "bold" }}>
                  <TableCell colSpan={8} style={{ textAlign: "right", fontWeight: "bold", fontSize: "0.95rem" }}>
                    รวมทั้งสิ้น ({filteredData.length} รายการ):
                  </TableCell>
                  <TableCell style={{ textAlign: "right", fontWeight: "bold", color: "#16a34a", fontSize: "1rem" }}>
                    {filteredData.reduce((acc, curr) => acc + Number(curr.amount || 0), 0).toLocaleString("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {/* Modal Popup: ออกเลขหนังสือ / ออกเลขใบเสร็จ */}
      <Dialog
        open={modalOpen}
        onClose={() => !modalSaving && setModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle style={{ borderBottom: "1px solid #e2e8f0", padding: "14px 24px" }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" style={{ fontWeight: "bold", color: "#0f172a", display: "flex", alignItems: "center", gap: 8 }}>
              <ConfirmationNumberIcon style={{ color: "#2563eb" }} />
              ออกเลขเล่มที่และเลขที่ใบเสร็จ
            </Typography>
            <IconButton
              size="small"
              onClick={() => !modalSaving && setModalOpen(false)}
              disabled={modalSaving}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{ padding: "20px 24px" }}>
          {modalError && (
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              p={1.5}
              mb={2}
              style={{
                backgroundColor: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 6,
                color: "#b91c1c",
                fontSize: "0.875rem"
              }}
            >
              <ErrorOutlineIcon fontSize="small" />
              <span>{modalError}</span>
            </Box>
          )}

          {/* Info Banner */}
          <Box
            p={1.5}
            mb={2.5}
            style={{
              backgroundColor: "#eff6ff",
              border: "1px solid #bfdbfe",
              borderRadius: 8,
              fontSize: "0.875rem",
              color: "#1e40af"
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <InfoIcon fontSize="small" />
              <strong>รายการที่จะบันทึกออกเลข: {selectedItems.length} รายการ</strong>
            </Box>
            <Typography variant="caption" style={{ display: "block", marginTop: 4, color: "#3b82f6" }}>
              * กฎการรันเลข: DocNum รันตั้งแต่ 1 ถึง 99 เมื่อถึง 99 จะหยุดที่ 99 แล้วขึ้น BookNum เล่มใหม่ (+1) และเริ่ม DocNum ที่ 1 อัตโนมัติ
            </Typography>
          </Box>

          {/* Form Inputs: BookNum, DocNum & ผู้ออกใบเสร็จ */}
          <Grid container spacing={2} style={{ marginBottom: 20 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="เล่มที่ (BookNum) *"
                placeholder="เช่น 1002"
                variant="outlined"
                size="small"
                value={startBookNum}
                onChange={e => setStartBookNum(e.target.value.replace(/\D/g, ""))}
                disabled={modalSaving}
                autoFocus
                helperText="ระบุตัวเลขเล่มที่ เช่น 1002"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="เลขที่เริ่มต้น (DocNum 1-99) *"
                placeholder="เช่น 8 หรือ 08"
                variant="outlined"
                size="small"
                value={startDocNum}
                onChange={e => setStartDocNum(e.target.value.replace(/\D/g, ""))}
                disabled={modalSaving}
                helperText="ระบุเลขที่เริ่มต้น เช่น 8 (รันได้ถึง 99)"
              />
            </Grid>
            <Grid item xs={12}>
              <TSSelect2
                label="ผู้ออกใบเสร็จ *"
                placeholder="-- เลือกผู้ออกใบเสร็จ --"
                options={recorders.map(r => ({
                  value: r.recorderKey,
                  label: r.recorderName || `ผู้ใช้งาน #${r.recorderKey}`
                }))}
                value={selectedRecorderKey}
                onChange={opt => setSelectedRecorderKey(opt ? opt.value : "")}
                isClearable={false}
                isDisabled={modalSaving}
              />
            </Grid>
          </Grid>

          {/* Warning Banner if Rollover happens */}
          {hasBookRollover && (
            <Box
              p={1.5}
              mb={2}
              style={{
                backgroundColor: "#fef3c7",
                border: "1px solid #fde68a",
                borderRadius: 8,
                color: "#92400e",
                fontSize: "0.875rem",
                fontWeight: "bold"
              }}
            >
              ⚠️ มีการขึ้นเล่มใหม่: จากเล่ม {previewSequence[0].bookNum} ถึงเล่ม {previewSequence[previewSequence.length - 1].bookNum} (เนื่องจาก DocNum ถึง 99)
            </Box>
          )}

          {/* Live Preview List */}
          <Typography variant="subtitle2" style={{ fontWeight: "bold", color: "#334155", marginBottom: 8 }}>
            ตัวอย่างลำดับเลขที่จะออก ({previewSequence.length} รายการ):
          </Typography>

          <TableContainer
            component={Paper}
            variant="outlined"
            style={{ maxHeight: 260, overflowY: "auto", borderRadius: 8 }}
          >
            <Table size="small" className={classes.previewTable} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 45, textAlign: "center" }}>ลำดับ</TableCell>
                  <TableCell style={{ width: 90, textAlign: "center" }}>HN</TableCell>
                  <TableCell>ชื่อ-นามสกุล</TableCell>
                  <TableCell style={{ textAlign: "center" }}>เลขที่ใบเสร็จเดิม</TableCell>
                  <TableCell style={{ textAlign: "center", minWidth: 120 }}>
                    เล่มที่/เลขที่จะออกใหม่
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedItems.map((item, idx) => {
                  const preview = previewSequence[idx];
                  return (
                    <TableRow key={item.receiptHeaderKey || idx}>
                      <TableCell style={{ textAlign: "center", color: "#64748b" }}>
                        {idx + 1}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                        {item.hn || "-"}
                      </TableCell>
                      <TableCell>{item.fullName || "-"}</TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {item.receiptNo || "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {preview ? (
                          <Chip
                            size="small"
                            label={preview.formatted}
                            style={{
                              backgroundColor: "#dbeafe",
                              color: "#1d4ed8",
                              fontWeight: "bold"
                            }}
                          />
                        ) : (
                          <span style={{ color: "#94a3b8" }}>-</span>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions style={{ padding: "14px 24px", borderTop: "1px solid #e2e8f0" }}>
          <Button
            onClick={() => setModalOpen(false)}
            disabled={modalSaving}
            variant="outlined"
            style={{ borderRadius: 8 }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleConfirmAssign}
            disabled={modalSaving || previewSequence.length === 0}
            variant="contained"
            color="primary"
            startIcon={modalSaving ? <CircularProgress size={16} color="inherit" /> : <DoneAllIcon />}
            style={{
              borderRadius: 8,
              backgroundColor: previewSequence.length > 0 ? "#16a34a" : "#94a3b8",
              fontWeight: "bold"
            }}
          >
            {modalSaving ? "กำลังบันทึก..." : `ยืนยันออกเลข (${selectedItems.length} รายการ)`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal Popup: เปลี่ยนผู้ออกใบเสร็จรายบุคคล (เปลี่ยนได้แม้จะออกเลขแล้ว) */}
      <Dialog
        open={changeRecorderModalOpen}
        onClose={() => !changeRecorderSaving && setChangeRecorderModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ borderBottom: "1px solid #e2e8f0", padding: "14px 24px" }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" style={{ fontWeight: "bold", color: "#0f172a", display: "flex", alignItems: "center", gap: 8 }}>
              <PersonIcon style={{ color: "#2563eb" }} />
              เปลี่ยนผู้ออกใบเสร็จ
            </Typography>
            <IconButton
              size="small"
              onClick={() => !changeRecorderSaving && setChangeRecorderModalOpen(false)}
              disabled={changeRecorderSaving}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{ padding: "20px 24px" }}>
          {changeRecorderError && (
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              p={1.5}
              mb={2}
              style={{
                backgroundColor: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 6,
                color: "#b91c1c",
                fontSize: "0.875rem"
              }}
            >
              <ErrorOutlineIcon fontSize="small" />
              <span>{changeRecorderError}</span>
            </Box>
          )}

          {targetReceipt && (
            <Box
              p={2}
              mb={2.5}
              style={{
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                fontSize: "0.875rem"
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>ผู้ป่วย (HN)</Typography>
                  <Typography variant="body2" style={{ fontWeight: "bold", color: "#0f172a" }}>
                    {targetReceipt.fullName || "-"} {targetReceipt.hn ? `(${targetReceipt.hn})` : ""}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>เลขที่ใบเสร็จ / เล่มที่</Typography>
                  <Typography variant="body2" style={{ fontWeight: "bold", color: "#0f172a" }}>
                    {targetReceipt.receiptNo || "-"}{" "}
                    {targetReceipt.bookNum && targetReceipt.docNum ? `(เล่ม ${targetReceipt.bookNum}/${targetReceipt.docNum})` : ""}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>ยอดเงิน</Typography>
                  <Typography variant="body2" style={{ fontWeight: "bold", color: "#16a34a" }}>
                    {Number(targetReceipt.amount || 0).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" style={{ color: "#64748b", display: "block" }}>ผู้ออกใบเสร็จปัจจุบัน</Typography>
                  <Typography variant="body2" style={{ color: "#334155" }}>
                    {targetReceipt.recorderName || "ยังไม่ได้ระบุ"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}

          <div>
            <TSSelect2
              label="เลือกผู้ออกใบเสร็จคนใหม่ *"
              placeholder="-- เลือกผู้ออกใบเสร็จ --"
              options={recorders.map(r => ({
                value: r.recorderKey,
                label: r.recorderName || `ผู้ใช้งาน #${r.recorderKey}`
              }))}
              value={editRecorderKey}
              onChange={opt => setEditRecorderKey(opt ? opt.value : "")}
              isClearable={false}
              isDisabled={changeRecorderSaving}
            />
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "14px 24px", borderTop: "1px solid #e2e8f0" }}>
          <Button
            onClick={() => setChangeRecorderModalOpen(false)}
            disabled={changeRecorderSaving}
            variant="outlined"
            style={{ borderRadius: 8 }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleConfirmChangeRecorder}
            disabled={changeRecorderSaving || !editRecorderKey}
            variant="contained"
            color="primary"
            startIcon={changeRecorderSaving ? <CircularProgress size={16} color="inherit" /> : <DoneAllIcon />}
            style={{
              borderRadius: 8,
              backgroundColor: editRecorderKey ? "#2563eb" : "#94a3b8",
              fontWeight: "bold",
              color: "#ffffff"
            }}
          >
            {changeRecorderSaving ? "กำลังบันทึก..." : "บันทึกเปลี่ยนผู้ออกใบเสร็จ"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

